"use client";

import { followCta } from "@/app/utilities/link";
import { CategoryChips } from "@/composites/category";

import type { AlsoDiscoverContent } from "./read-also-discover";

export function AlsoDiscover({
	heading,
	links
}: AlsoDiscoverContent): JSX.Element | null {
	return (
		<CategoryChips
			heading={heading}
			links={links}
			onLinkPress={followCta}
		/>
	);
}
